<template>
  <el-select ref="package" v-model="selected" placeholder="Selecione  uma opção" @change="update()">
    <el-option-group v-for="group in packages" :key="group.label" :label="group.label">
      <el-option v-for="row of group.options" :key="row.id" :label="row.name" :value="row.id"></el-option>
    </el-option-group>
  </el-select>
</template>

<script>
import { PackingService } from "@/services/customers/packing.services";
export default {
  name: "PackingList",
  props: ["package"],
  data: function () {
    return {
      packages: [],
      selected: "",
    };
  },
  watch: {
    customer: function (v) {
      const vm = this;
      vm.fetchBranchs();
    },
  },
  methods: {
    find(id) {
      const vm = this;
      for (const row of vm.packages) {
        const record = row.options.find((x) => x.id === id);
        if (record) {
          return record;
        }
      }
      return null;
    },
    fetchBranchs() {
      const vm = this;
      PackingService.list('', '1')
        .then((response) => {
          if (
            response.records.filter((x) => x.customer !== "Padrão").length > 0
          ) {
            vm.packages.push({
              label: "Minhas embalagens",
              options: response.records.filter((x) => x.customer !== "Padrão"),
            });
          }
          vm.packages.push({
            label: "Embalagens padrões",
            options: response.records.filter((x) => x.customer === "Padrão"),
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchBranchs();
  },
};
</script>